import { ParsedUrlQuery } from "querystring";
import { ProductListingData } from "@/types/productListing";

export const loadChunkViaApiRoute = async (
  routerQuery: ParsedUrlQuery,
  chunk: number,
): Promise<ProductListingData> => {
  const { facetId, ...restOfQuery } = routerQuery;

  const formattedFacetId = Array.isArray(facetId)
    ? "/" + facetId.join("/")
    : facetId;

  const requestParams = new URLSearchParams({
    ...restOfQuery,
    chunk: String(chunk),
    ...(formattedFacetId ? { facetId: formattedFacetId } : {}),
  });

  const response = await fetch(
    `/web-plp-scaffold-ui/api/product-chunk?${requestParams.toString()}`,
  );

  if (!response.ok) {
    throw new Error(await response.text());
  }

  return await response.json();
};
